import { styled } from '@uhg-abyss/web/tools/styled';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { Text } from '@uhg-abyss/web/ui/Text';

export const StyledDrawer = styled(Drawer, {
  zIndex: '999 !important',
  '.abyss-modal-header-container': {
    width: 'fit-content',
    marginBottom: '8px',
    marginTop: '24px',
    '@media (max-width: 744px)': {
      marginTop: '39px',
    },
  },
  '.abyss-modal-content-container': {
    borderRadius: 0,

    '@media (max-width: 744px)': {
      top: '25px',
      height: 'calc(100vh - 26px)',
      width: '100%',
      borderRadius: '20px 20px 0px 0px',
      color: '$core.color.brand.100',
      border: '1px solid $core.color.brand.100',
    },
  },
  '.abyss-modal-close-button': {
    position: 'absolute',
    right: '24px',
    top: '12px',
    zIndex: '1000 !important',
    '@media (max-width: 744px)': {
      top: '12px',
      right: '12px',
    },
  },
  '.abyss-modal-content-title': {
    color: '$core.color.brand.100',
    fontFamily: '$primary',
    fontWeight: 'bold',
    fontSize: '32.43px',
    lineHeight: '40px',
    paddingTop: '0px',
  },
  '.abyss-modal-body': {
    padding: '0px 16px 16px 16px',
    scrollbarWidth: 'none' /* Hide scrollbar for Chrome, Safari and Opera */,
    '::-webkit-scrollbar': {
      display: 'none',
    },
  },
  '.abyss-modal-footer': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '16px',
    '@media (max-width: 744px)': {
      paddingBottom: '30px',
    },
  },
});

export const StyledSubHeading = styled(Text, {
  fontWeight: 'bold',
  fontSize: '18px',
  lineHeight: '24px',
  color: '$core.color.brand.100 !important',
});

export const EditComparisonDrawerDescription = styled(Text, {
  fontSize: '16px',
  lineHeight: '20px',
  color: '#323334',
  fontWeight: '400',
  letterSpacing: '0px !important',
});
